<div class="chart-wrap" [style.height.px]="heightPx">
  <canvas #canvas></canvas>
</div>

